module.exports = __webpack_public_path__ + "img/EdConnect Login Button_Eng.9129c908.png";